import { openDB } from 'idb';

const DB_NAME = 'taga_admin_data';
const STORE_NAME = 'polygons';

export async function getDB() {
  return openDB(DB_NAME, 1, {
    upgrade(db) {
      if (!db.objectStoreNames.contains(STORE_NAME)) {
        db.createObjectStore(STORE_NAME);
      }
    },
  });
}

export async function saveHexagons(data) {
  await saveData('polygons_polls', data);
}

export async function saveWardHexagons(data) {
  await saveData('polygons_ward', data);
}

export async function loadHexagons() {
  return await loadData('polygons_polls');
}

export async function loadWardHexagons() {
  return await loadData('polygons_ward');
}

export async function loadCrimePoints() {
  return await loadData('points_crimes')
}

export async function saveCrimePoints(data) {
  await saveData('points_crimes', data);
}

export async function saveData(name, data) {
  const db = await getDB();
  await db.put(STORE_NAME, data, name);
}

export async function loadData(name) {
  const db = await getDB();
  return db.get(STORE_NAME, name);
}
